<template>
    <div id="instant">
        <h1 class="title">{{projectNo}}-{{Title}}</h1>
        <div v-for="(bidder,Bidindex) in NewScore" :key="Bidindex" class="biTable">
            <h3 style="text-align: left">{{bidder.sort}}:{{bidder.bidder}}</h3>
            <table cellspacing="0" cellpadding="0" border="1" style="border: 1px solid #DDDDDD;" class="toptable">
                <tr>
                    <th v-for="(thead,tIndex) in columns" :key="tIndex" style="width: 50px" v-if="(tIndex!=columns.length-1)||isShowPrice">
                        <span v-if="thead.sort!=-1">{{thead.isObjective?'客':'主'}}(序号{{thead.sort}})</span>
                        {{thead.title}}
                    </th>
                </tr>
                <tr v-for="(tbody,bIndex) in bidder.experts" :key="bIndex">
                    <td>{{tbody.name}}</td>
                    <td v-for="(score,scIndex) in tbody.scoreList" :style="{color: score.result==null?'red':(score.isUnOK?'blue':''),'font-weight': score.isUnOK?'700':''}" :key="scIndex" v-if="(scIndex!=tbody.scoreList.length-1)||isShowPrice">{{score.result|tofixed(scIndex==columns.length-2?pricePlace:2)}}</td>
                </tr>
            </table>
            <div class="foot">[{{bidder.bidder}}]的得分：{{bidder.Total|tofixed(pricePlace)}}</div>
            <div class="line" v-if="Bidindex!=NewScore.length-1"></div>
        </div>
        <div class="biTable">
            <table cellspacing="0" cellpadding="0" border="1" style="border: 1px solid #DDDDDD;table-layout: fixed" class="toptable">
                <tr>
                    <th style="width: 100px">
                        评分项序号
                    </th>
                    <th style="width: 100px">
                        是否客观分
                    </th>
                    <th >
                        评分项详细内容
                    </th>
                </tr>
                <tr v-for="(cons,conIndex) in constract" :key="conIndex">
                    <td>序号{{cons.sort}}</td>
                    <td>{{cons.isObjective?'是':'否'}}</td>
                    <td style="word-wrap: break-word;text-align: left;padding: 0 10px;text-indent: 2em;">{{cons.itemContent}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import ajax from '@/lib/ajax'
import requesturls from '@/lib/requestUrls'
import { log } from 'util';
export default {
    data:()=>{
        return {
            isShowPrice: false,//是否显示价格分
            projectNo: '',//项目编号
            bidderData: [],//按专家分组投标人列表
            ScoreTable: [],//按投标人分组的评分结果列表
            NewScore: [],//新评分结果
            TypeList: [],//分值类型
            projectID: 0,//项目id
            groupID: 0,//包组id
            Title: '',//项目标题
            columns: [//table表头
                {
                    title: '评委',
                    key: 'name',
                    align: 'center',
                    sort: -1
                }
            ],
            isprint: true,//打印按钮显示
            constract: [],//评分项对照表
            pricePlace: 2,//价格分保留小数位
        }
    },
    methods:{
        async getNewdetails(New){
            //各投标人总分
            let temp = {}//存放投标人的总分
            let BidSum = await ajax.get(requesturls.AbpReporting.GetInstantPageSumScore+`?projectId=${this.projectID}&groupId=${this.groupID}`)
            BidSum.data.result.forEach(sum=>{
                this.$set(temp,sum.bidderName,sum.sumScore)
            })
            let scoredetails = {}//存放评分项细节
            New.groupDb[0].scoreItems.forEach(detail=>{
                this.$set(scoredetails,detail.id,{max:detail.maxValue,sort:detail.sort,isObjective: detail.isObjective})
            })
            //获取分数类型
            let map = new Map()
            let scoreitems = New.groupDb[0].scoreItems.filter(type=> !map.has(type.itemType)&&map.set(type.itemType,1)).map(item=>{return item.itemType})
            // console.log(JSON.parse(JSON.stringify(scoreitems)))
            this.constract = New.groupDb[0].scoreItems.filter(con=>{return con.itemType!='价格分'}).map(cons=>{
                return {
                    sort: cons.sort,
                    itemContent: cons.itemContent,
                    isObjective: cons.isObjective
                    // itemType: cons.itemType
                }
            })
            BidSum.data.result.forEach((bidder,BidIndex)=>{//投标人
                this.NewScore.push({bidder: bidder.bidderName,experts:[],Total: temp[bidder.bidderName],sort: bidder.sorting})
                New.groupDb[0].bidderExpoerts.forEach(BidExpert=>{//获取对应专家
                    if(BidExpert.bidderName==bidder.bidderName){
                        let detailList = {}//每个专家分数列表
                        scoreitems.forEach(scoreItem=>{//分数类型
                            this.$set(detailList,scoreItem,[])//以分值类型为键名
                            let CurrentScore = 0//当前分数类型分值总和
                            New.groupDb[0].scoreItems.forEach(scorModel=>{//评分项排序
                                if(BidExpert.scoreResults!=null){//判断是否已保存评分
                                    BidExpert.scoreResults.forEach(score=>{
                                        if(score.itemType==scoreItem&&score.scoreItemId==scorModel.id){
                                            detailList[scoreItem].push({...score,maxValue: scoredetails[score.scoreItemId].max,sort: scoredetails[score.scoreItemId].sort,isObjective: scoredetails[score.scoreItemId].isObjective})
                                            CurrentScore = CurrentScore + score.result
                                        }
                                    })
                                }else{//评分未保存
                                    if(scoreItem==scorModel.itemType){
                                        // detailList[scoreItem].push({...scorModel,result: null,scoreItemId: scorModel.id,maxValue: scorModel.max,sort: scorModel.sort,isObjective: scorModel.isObjective})
                                        detailList[scoreItem].push({...scorModel,result: null,scoreItemId: scorModel.id,maxValue: scorModel.maxValue,sort: scorModel.sort,isObjective: scorModel.isObjective})
                                    }
                                }
                            })
                            detailList[scoreItem].push({itemType: scoreItem,result: CurrentScore,istotal: true})
                            detailList['价格分'] = [{itemType: '价格分',result: BidExpert.priceScore,istotal: true}]//获取价格分
                        })
                        this.NewScore[BidIndex].experts.push({name: BidExpert.expertName,...detailList})
                    }
                })
                //判断客观分是否一致
                scoreitems.forEach(type=>{//分值类型
                    if(type!='价格分'){
                        this.NewScore[BidIndex].experts[0][type].forEach((score,sIndex)=>{//先遍历查询对应评分项
                            if(sIndex<this.NewScore[BidIndex].experts[0][type].length-1&&score.isObjective){//最后一个是对应类型的总分，不检验;只判断客观分
                                let model = score.result
                                let isUnOK = false
                                this.NewScore[BidIndex].experts.forEach(exp=>{//遍历专家，检查分数是否一致
                                    if(exp[type][sIndex].result!=model){
                                        isUnOK = true
                                    }
                                })
                                this.NewScore[BidIndex].experts.forEach(exp=>{//对不一致的项添加字段
                                    if(isUnOK){
                                        exp[type][sIndex].isUnOK = true
                                    }
                                })
                            }
                        })
                    }
                })
            })
            //获取分值类型
            for(let key in this.NewScore[0].experts[0]){
                if(key!='价格分'&&key!='name'){
                    this.TypeList.push(key)
                }
            }
            this.TypeList.push('价格分')   
            this.getTbody()
            //生成column
            this.NewgetColumn()
        },
        NewgetColumn(){
            this.TypeList.forEach(type=>{
                if(type!='价格分'){
                        this.columns.push(
                            ...this.NewScore[0].experts[0][type].map((score,scIndex)=>{
                                return {//各分值类型细节分数
                                    title: score.istotal?type.replace('分','总分'):score.maxValue,
                                    align: 'center',
                                    sort: score.sort?score.sort:-1,
                                    isObjective: score.isObjective,
                                    render:(h,params)=>{
                                        return h('div',params.row[type][scIndex].result)
                                    }
                                }
                            })
                        )
                    }else{
                        this.columns.push({
                            title: type,
                            align: 'center',
                            sort: -1,
                            render:(h,params)=>{
                                return h('div',params.row[type][0].result)                                
                            }
                        })
                    }
            })
            
        },
        getTbody(){
            this.NewScore.forEach((expert,eIndex)=>{
                expert.experts.forEach((score,sIndex)=>{
                    this.$set(this.NewScore[eIndex].experts[sIndex],'scoreList',[])
                    this.TypeList.forEach(type=>{
                        score[type].forEach(detail=>{
                            this.NewScore[eIndex].experts[sIndex].scoreList.push({result:detail.result,isUnOK: detail.isUnOK})
                        })
                    })
                })
            })
        }
    },
    async created(){
        //获取路由传来的参数
        this.projectID = this.$route.query.projectID
        this.groupID = this.$route.query.groupID
        this.Title = this.$route.query.Title
        // ------------------------------ //
        //新接口获取即时页面数据
        let New = await ajax.get(requesturls.AbpReporting.GetInstantPageReport+`?projectId=${this.projectID}&groupId=${this.groupID}`)
        this.getNewdetails(New.data.result)
        this.projectNo = New.data.result.projectFull
        //---------------获取包组设置-----------------//
        let res = await ajax.get(requesturls.GroupSetting.GetByGroupId+'?id='+this.groupID)
        this.isShowPrice = res.data.result.isShowPricePoints
        this.pricePlace = res.data.result.priceDecimalPlaces!=null?res.data.result.priceDecimalPlaces:2
    },
    filters:{
        tofixed(val,place=2){
            return parseFloat(val).toFixed(place)
        }
    }
}
</script>
<style lang="less">
body{
    overflow: auto!important;
    padding-top: 1px;
    color: black;
    font-size: 15px;
    min-height: 798px;
}

#instant{
    width:95%;
    margin: 10px auto;
    .ivu-table td{
        height: 30px;
    }
}
.title{
    text-align: center;
    margin: 10px 0;
}
.biTable {
    // margin-bottom: 10px;
    margin: 5px auto 5px auto;
}
.foot {
    font-size: 20px;
    color: red;
    font-weight: 700;
    padding-top: 5px;
}
.line{
    width: 100%;
    margin-top: 5px;
    border: 0.5px dotted #cdcdcd;
}
.toptable{
    border-collapse:collapse;
    width: max-content;
    margin: 10px 0;
    min-width: 100%;
    line-height: 25px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    text-align: center;
}
</style>
